import LXCenter from '../core/components/center';
import SignInForm from './components/signInForm';
const SignInPage: React.FC = () => {
  return (
    <LXCenter>
      <SignInForm></SignInForm>
    </LXCenter>
  );
};

export default SignInPage;
